module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/icon_day1-1b0e11835436cb2e72fedfe3f489c730.svg";